import { Container } from "@mui/material";
import React from "react";
import DesktopMenu from "./component/DesktopMenu";
import MobileMenu from "./component/MobileMenu";
import twitter from "../../../assets/images/twitter.png"
import telegram from "../../../assets/images/telegram.png"
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
const LockerMenu = (props) => {
  const handleClick = () => {
    const textToCopy = 'TBA';
    navigator.clipboard.writeText(textToCopy);
    toast.success('TBA');
  };

  const menuList = [
    // You can pass 4 perameters for menu title, link, target and customClass

    {
      title: "Home",
      link: "/#home",
    },
    {
      title: "About",
      link: "/#about",
    },
    {
      title: "Tokenomics",
      link: "/#tokenomics",
    },
    {
      title: <img src={twitter}/>,
      link: "https://twitter.com/rhparody",
      target:"blank"
    },
    {
      title: <img src={telegram}/>,
      link: "https://t.me/rhparody",
      target:"blank"
    },
  ];
  return (
    <Container maxWidth="xl"
      data-aos="fade-zoom-in"
      data-aos-easing="ease-in"
      data-aos-delay="400"
      data-aos-duration="400"
      data-aos-offset="0">
      <DesktopMenu menuList={menuList} />
      <MobileMenu menuList={menuList} />
      
      <ToastContainer />
    </Container>
  );
};

export default LockerMenu;
